import { Queue } from './Queue';
import { Devices } from './Devices';
import { Details } from './Details';

// Redux
import { memo } from 'react';
import { useAppSelector } from '../../../../store/store';

export const PlayingNow = memo(() => {
  const queue = useAppSelector((state) => !state.ui.queueCollapsed);
  const details = useAppSelector((state) => !state.ui.detailsCollapsed);
  const devices = useAppSelector((state) => !state.ui.devicesCollapsed);

  if (devices) return <Devices />;
  if (queue) return <Queue />;
  if (details) return <Details />;

  return null;
});
